<template lang="pug">
  l-geoJson(
    v-if="state.instituciones"
    :geojson="geoJson"
    :options="options"
  )
</template>

<script>
import L from 'leaflet'
import { mapGetters } from 'vuex'
import markerMixin from '@/mixins/marker-for-instituciones.js'

export default {
  mixins: [ markerMixin ],
  methods: {
    showDetalle (institucion, event) {
      this.$emit('show-detail', { institucion })
    },
    buildPopup (item) {
      return `
          <h4>${item['institucion_afectada']}</h4>
        `
    },
    buildIcon (item) {
      let tipoInstitucionIcon
      switch (item.tipo_institucion) {
        case 'Comisarias':
          tipoInstitucionIcon = 'Comisaria'
          break
        case 'Instituciones Educativas':
          tipoInstitucionIcon = 'Institucion-educativa'
          break
        case 'Instituciones de Salud':
          tipoInstitucionIcon = 'Institucion-salud'
          break
        default:
          tipoInstitucionIcon = 'Institucion-religiosa'
      }
      return L.divIcon({
        className: `makerBlueIcon instituciones`,
        html: `
          <div>
            <div class="ap-pin ${tipoInstitucionIcon}">
              <span class="ap-${tipoInstitucionIcon} sub-icon"></span>
            </div>
          </div>
        `,
        iconSize: [45, 45]
      })
    }
  },
  computed: {
    ...mapGetters({ geoJson: 'instituciones', state: 'interfaceState', markerData: 'institucion' })
  }
}
</script>

<style lang="stylus">
@import '~@/styles/variables'
@import '~@/styles/refugios/variables'
@import '~@/styles/instituciones/variables'

.leaflet-tooltip-pane
  .datos
    font-size: $f13px
    color: $color_0
  h4
    color: $color_0
    font-size: $f15px
    font-weight: bold
    margin: 0

.makerBlueIcon
  .ap-pin
    &.Comisaria
      color: $comisariaColor
    &.Institucion-educativa
      color: $escuelaColor
    &.Institucion-salud
      color: $hospitalColor
    &.Institucion-religiosa
      color: $iglesiaColor
    .sub-icon
      &.ap-Comisaria
        font-size: 17px
        left: 15.5px
        top: 9px
      &.ap-Institucion-educativa
        font-size: 20px
        left: 12.5px
      &.ap-Institucion-salud
        font-size: 14px
        top: 10px
        left: 15px
      &.ap-Institucion-religiosa
        font-size: 17px
  &.active
    .ap-pin
      &.Comisaria
        .sub-icon
          font-size: 34px
          left: 23.5px
      &.Institucion-educativa
        .sub-icon
          font-size: 40px
          top: 10px
          left: 18px
      &.Institucion-salud
        .sub-icon
          font-size: 35px
          top: 11px
          left: 20px
      &.Institucion-religiosa
        .sub-icon
          font-size: 30px
          top: 11px
          left: 22.5px
</style>
